import React from 'react';
import { FormattedMessage } from 'react-intl';
import ShortBaseSwVersion from '~/features/baseSwVersions/components/ShortBaseSwVersion';
import FieldOrNoData from '~/features/base/components/FieldOrNoData';
import { updateOutcome } from '~/features/devices/constants/deviceRolloutStates';
import { getSubstringAfterUnderscore } from '~/features/base/utils/stringUtils';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import {updateEventTypes} from "~/features/updateEvents/constants/updateEventTypes";

const LastRolloutStateItem = ({ field }) => {
    try {
        if (Array.isArray(field)) {
            return (
                <>
                    {field.map(rolloutState => {
                        if (!rolloutState.outcome) return null;

                        const content = (
                            <>
                                <FormattedMessage id={updateOutcome[rolloutState.outcome].tooltip}/>
                                <FormattedMessage id={getSubstringAfterUnderscore(rolloutState.type)}/>:
                                [{rolloutState.deliverableId}@<ShortBaseSwVersion
                                baseSwVersion={rolloutState.version}/>]
                            </>
                        );

                        if (rolloutState.subProgress && Array.isArray(rolloutState.subProgress)) {
                            return (
                                <div key={`${rolloutState.deliverableId}-${rolloutState.version}`}>
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={
                                            <Tooltip id={`tooltip-${rolloutState.deliverableId}`}>
                                                {rolloutState.subProgress.map(sub => (
                                                    <div key={`${sub.deliverableId}-${sub.version?.major}-${sub.version?.minor}-${sub.version?.patch}`}>
                                                        <FormattedMessage id={updateOutcome[sub.outcome]?.tooltip}/>
                                                        <FormattedMessage id={getSubstringAfterUnderscore(rolloutState.type)}/>:
                                                        [{sub.deliverableId}@<ShortBaseSwVersion baseSwVersion={sub.version}/>]
                                                    </div>
                                                ))}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{content}</span>
                                    </OverlayTrigger>
                                </div>
                            );
                        }

                        return (
                            <div key={`${rolloutState.deliverableId}-${rolloutState.version}`}>
                                {content}
                            </div>
                        );
                    })}
                </>
            );
        } else {
            return <FieldOrNoData field={field}/>;
        }
    } catch (e) {
        return <FormattedMessage id={'intl-msg:error.somethingWentWrong'}/>;
    }
};

export default LastRolloutStateItem;
